import { useQuery } from '@tanstack/react-query';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { getSpringboardCategories } from '@/shared/api/springboard-categories.api';
import { SPRINGBOARD_CATEGORIES_QUERY_KEYS } from '@/shared/constants/springboard-categories-query-keys';

export const useSpringboardCategoryCustomization = () => {
  const workspaceId = useCurrentWorkspaceId() ?? '';

  return useQuery({
    queryKey: SPRINGBOARD_CATEGORIES_QUERY_KEYS.categories(workspaceId),
    queryFn: () => getSpringboardCategories(workspaceId),
    enabled: !!workspaceId,
    staleTime: 5 * 60 * 1000,
  });
};
